import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/3.jpg';
import Avatar from 'components/common/Avatar';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';

import getAcademy from 'api/academy/get-academy';
import getProfile from 'api/user/get-profile';
import ACTION_TYPE from '../../../dux/auth/ACTION_TYPE';

const mapStateToProp = state => ({
  avatar: state.auth.avatar,
  academyId: state.auth.academyId,
  uuid: state.auth.uuid
});

const ProfileDropdown = ({ dispatch }) => {
  const avatar = useSelector(state => state.auth.avatar);
  const academyId = useSelector(state => state.auth.academyId);
  const uuid = useSelector(state => state.auth.uuid);
  const isAcademy = useSelector(state => state.auth.isAcademy);

  useEffect(() => {
    getAvatarFech();
  }, []);

  const getAvatarFech = async () => {
    var data = {};

    if (isAcademy) {
      data = await getAcademy(academyId);
    } else {
      data = await getProfile(uuid);
    }
    if (data) {
      dispatch({
        type: ACTION_TYPE.SET_AVATAR,
        avatar: data[0].avatarUrl
      });
    }
  };

  const { t } = useTranslation();
  // emitAvatarChange();
  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 nav-link"
      >
        <Avatar src={avatar || team3} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {false && (
            <>
              <Dropdown.Item className="fw-bold text-warning" href="#!">
                <FontAwesomeIcon icon="crown" className="me-1" />
                <span>Go Pro</span>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="#!">Set status</Dropdown.Item>
              <Dropdown.Item as={Link} to="/pages/profile">
                Profile &amp; account
              </Dropdown.Item>
              <Dropdown.Item href="#!">Feedback</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item as={Link} to="/pages/settings">
                Settings
              </Dropdown.Item>
            </>
          )}
          {isAcademy && (
            <div>
              <Dropdown.Item as={Link} to="/dashboard/subscriptions">
                {t('subscriptions.title')}
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/dashboard/credits">
                {t('credits.title')}
              </Dropdown.Item>
            </div>
          )}

          <Dropdown.Item as={Link} to="/logout">
            {t('logoutText')}
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default connect(mapStateToProp)(ProfileDropdown);
